import styled from 'styled-components';

export const EyeImage = styled.button`
  width: auto;
  height: auto;
  opacity: 0.3;
  border: 0;
  background-color: transparent;
  font-size: 11px;
  padding: 0;

  &:hover,
  &:focus {
    opacity: 0.5;
  }
`;

export const TextInputStyle = styled.div<{ width?: string }>`
  width: ${(p) => p.width ?? '100%'};
  position: relative;
`;
